// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1Dgzr","info":"UpdateTermsInfo_info__3X0S1"};